import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.symtom.loading;
export const symtomErrorMessage = (state: RootState) => state.symtom.error;
export const symtomDataResponse = (state: RootState) =>
  state.symtom.symtomResponse;
